var FILTER_TYPE1 = {
  id: 'technician1',
  name: __('Technician1'),
  type: 'SINGLE_SELECT',
  additional: {
    options: [{
      label: 'Kyran Beattie',
      value: '1'
    }, {
      label: 'Hendrix Arias',
      value: '2'
    }, {
      label: 'Sean Cole',
      value: '3'
    }, {
      label: 'Aarav Woodley',
      value: '4'
    }, {
      label: 'Ayra Greer',
      value: '5'
    }]
  }
};
var FILTER_TYPE2 = {
  id: 'technician2',
  name: __('Technician2'),
  type: 'NUMBER',
  additional: {
    options: [{
      label: 'Kyran Beattie',
      value: '1'
    }, {
      label: 'Hendrix Arias',
      value: '2'
    }, {
      label: 'Sean Cole',
      value: '3'
    }, {
      label: 'Aarav Woodley',
      value: '4'
    }, {
      label: 'Ayra Greer',
      value: '5'
    }]
  }
};
var FILTER_TYPE3 = {
  id: 'technician3',
  name: __('Technician3'),
  type: 'MULTI_SELECT',
  additional: {
    options: [{
      label: 'Kyran Beattie',
      value: '1'
    }, {
      label: 'Hendrix Arias',
      value: '2'
    }, {
      label: 'Sean Cole',
      value: '3'
    }, {
      label: 'Aarav Woodley',
      value: '4'
    }, {
      label: 'Ayra Greer',
      value: '5'
    }]
  }
};
var FILTER_TYPE4 = {
  id: 'technician4',
  name: __('Technician4'),
  type: 'SINGLE_SELECT',
  additional: {
    options: [{
      label: 'Kyran Beattie',
      value: '1'
    }, {
      label: 'Hendrix Arias',
      value: '2'
    }, {
      label: 'Sean Cole',
      value: '3'
    }, {
      label: 'Aarav Woodley',
      value: '4'
    }, {
      label: 'Ayra Greer',
      value: '5'
    }]
  }
};
var FILTER_TYPE5 = {
  id: 'technician5',
  name: __('Technician5'),
  type: 'SINGLE_SELECT',
  additional: {
    options: [{
      label: 'Kyran Beattie',
      value: '1'
    }, {
      label: 'Hendrix Arias',
      value: '2'
    }, {
      label: 'Sean Cole',
      value: '3'
    }, {
      label: 'Aarav Woodley',
      value: '4'
    }, {
      label: 'Ayra Greer',
      value: '5'
    }]
  }
};
var FILTER_TYPE6 = {
  id: 'technician6',
  name: __('Technician6'),
  type: 'SINGLE_SELECT',
  additional: {
    options: [{
      label: 'Kyran Beattie',
      value: '1'
    }, {
      label: 'Hendrix Arias',
      value: '2'
    }, {
      label: 'Sean Cole',
      value: '3'
    }, {
      label: 'Aarav Woodley',
      value: '4'
    }, {
      label: 'Ayra Greer',
      value: '5'
    }]
  }
};
var FILTER_TYPES = [FILTER_TYPE1, FILTER_TYPE2, FILTER_TYPE3, FILTER_TYPE4, FILTER_TYPE5, FILTER_TYPE6];
export var DEFAULT_FILTER_TYPES = [FILTER_TYPE1.id, FILTER_TYPE3.id];
export default FILTER_TYPES;